import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useJwt } from "react-jwt"
import { CreateSlider, GetAllMedia, GetCategoryImage, GetProductStatus, api_url } from '../apiconfig/authService';

function AddSlider(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  const setMediaTableViewMessage = props.setMessage;

  const [statusid, setStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);
  const [mediaData, setMediaData] = useState([]);
  const [selectedMedias, setSelectedMedias] = useState([]);

  const [sliderTitle, setSliderTitle] = useState('');
  const [message, setMessage] = useState('');
  const [isMessageRed, setIsMessageRed] = useState('');

  const handleSliderTitleChange = (e) => {
    setSliderTitle(e.target.value);
  };

  const handleStatusIdChange = (e) => {
    setStatusid(e.target.value);
  };

  const handleImageClick = (mediaid) => {
    const isSelected = selectedMedias.some((item) => item === mediaid);

    if (isSelected) {
      setSelectedMedias(selectedMedias.filter((item) => item !== mediaid));
    } else {
      setSelectedMedias([...selectedMedias, mediaid]);
    }
  };

  const validateInput = () => {
    if (sliderTitle === '')
      throw new Error('Slider title is required.');
  };


  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const requestBody = {
      title: sliderTitle,
      relatedMedias: selectedMedias,
      statusid
    };
    try {
      response = await CreateSlider(requestBody, localStorage.getItem('accessToken'));
      if (response.status === 201) {
        setMediaTableViewMessage(response.data.message);
        navigate("/slider");
      }
    } catch (err) {
      if ((err.response && err.response.data) && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage('An error occurred. Please try again later.');
        window.scrollTo(0, 0);
      }
    }
  };

  useEffect(() => {
    (
      async () => {
        try {

          const statusResponse = await GetProductStatus(localStorage.getItem('accessToken'));
          setStatusData(statusResponse.data);
        } catch (error) {
          console.log(error);
        }
      }
    )();
    (
      async () => {
        try {
          const mediaResponse = await GetAllMedia(localStorage.getItem('accessToken'));
          setMediaData(mediaResponse.data);
        } catch (error) {
          console.log(error);
        }
      }
    )();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Slider</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/media" className="btn btn-primary">View All</NavLink>
          </div>
        </div>

        {message && <div style={{ color: isMessageRed ? 'red' : 'black' }} className="alert alert-primary" role="alert">{message}</div>}

        <div role="tabpanel" className="personal-info tab-pane active" id="pi">
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-4">
                <input type="text" value={sliderTitle} onChange={handleSliderTitleChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Slider Title</label>
              </div>
            </div>
          </div>
          <div className="form-floating mb-4">
            <select className="form-select" onChange={handleStatusIdChange} value={statusid} >
              {
                statusData?.map((item) => (
                  <option value={item.statusid}>
                    {item.status}
                  </option>
                ))
              }
            </select>
            <label htmlFor="floatingInput">Status</label>
          </div>
          <div className='row'>
            {
              mediaData?.map((item) => (
                <div className='col-lg-2'>
                  <input className="form-check-input" onChange={() => handleImageClick(item.mediaid)} checked={selectedMedias.find(mediaid => mediaid === item.mediaid)} type="checkbox" />
                  <img width="100px" height="100px" onClick={() => handleImageClick(item.mediaid)} style={{ marginLeft: 20, marginRight: 20, marginBottom: 20 }} src={`${api_url}/product/category/getCategoryImage/${item.image}`} />
                </div>
              ))
            }
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button type="submit" onClick={handleSubmitClick} className="btn btn-primary btn save-btn text-uppercase px-4">Add</button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddSlider;
